/*
    TouchWeb and UserRegistration share this state in the sessionStorage.
    Any changes in key names or logic needs to be synced on the other side.
*/

import Analytics from 'packages/analytics';

class AnalyticsStorage {
    constructor(key = '') {
        this._key = key;
        this.set = (value = '') => {
            sessionStorage.setItem(this._key, value);
        };
        this.setIfEmpty = (value = '') => {
            if (!sessionStorage.getItem(this._key)) {
                sessionStorage.setItem(this._key, value);
            }
        };
        this.get = () => {
            const value = sessionStorage.getItem(this._key);
            return value ? value : undefined;
        };
        this.clear = () => {
            sessionStorage.removeItem(this._key);
        };
    }
}

export const flow = new AnalyticsStorage('tradera.loginSignup.flow');
export const method = new AnalyticsStorage('tradera.loginSignup.method');

export const FLOW = {
    LOGIN: 'login',
    SIGNUP: 'signup',
    UNKNOWN: 'unknown'
};
export const METHOD = {
    PASSWORD: 'password',
    FACEBOOK: 'facebook',
    GOOGLE: 'google',
    KLARNA: 'klarna',
    UNKNOWN: 'unknown'
};

export function trackEvent(event = '', memberId = 0, validationError = '') {
    const data = {
        event: event,
        method: method.get() || METHOD.UNKNOWN,
        'initial-flow': flow.get() || FLOW.UNKNOWN
    };
    if (memberId) {
        data['member-id'] = '' + memberId;
    }
    if (validationError) {
        data['validation-error'] = validationError;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}

export function trackButtonClick() {
    Analytics.trackEvent({
        category: 'Top navigation',
        action: 'Login menu',
        label: 'Login'
    });
}
